<div class="row justify-content-center">
    <mat-progress-spinner [diameter]="50" mode="indeterminate"></mat-progress-spinner>
</div>
<br>
<div class="row justify-content-center">
    <p>{{ texto }}</p>
</div>

<div class="row justify-content-center">
    <p>Por favor, aguarde um momento!</p>
</div>